import OtpInput from "react-otp-input";
import styled, { css } from "styled-components";
import { Flex } from "../Flex";
import { getThemeFontSize, getThemeLineHeight, getThemeSpace } from "../helpers";
export const OTPWrapper = styled.div `
	i[data-testid^='icon'] {
		display: none;
	}

	footer.without-message {
		top: 122px;
		right: auto;
		left: 3px;
	}
`;
export const InputsWrapper = styled(Flex) `
	position: relative;

	div {
		display: flex;
		gap: ${getThemeSpace("8")};
	}
`;
export const Input = styled(OtpInput) `
	--gray-disabled: var(--surface-primary); // temp color
	--blue: #0077cb; // temp color

	input {
		border: 2px solid var(--border-primary);
		border-radius: 8px;
		padding: ${getThemeSpace("16")} 0;

		height: 100%;
		max-height: 56px;
		max-width: 40px;
		width: 100% !important;

		appearance: none;
		background-color: var(--surface-white);
		font-size: ${getThemeFontSize("24")};
		line-height: ${getThemeLineHeight("medium")};
		transition: all 300ms ease-in-out;
		text-align: center;

		${({ feedback }) => feedback === "error" &&
    css `
				border-color: var(--border-error) !important;
			`}

		&:disabled {
			background-color: var(--surface-white);
			border-color: var(--gray-disabled);
			cursor: not-allowed;
			color: var(--gray-disabled);
		}

		&:focus {
			outline: var(--blue) auto 2px;
		}
	}
`;
//# sourceMappingURL=styles.js.map